// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"IconButton_iconButton__5434W","iconOnly":"IconButton_iconOnly__493gD","iconSlot":"IconButton_iconSlot__pTFdr","hasIcon":"IconButton_hasIcon__Dyqlb"};